var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"1"}},[_vm._v("   ")]),_c('b-col',{attrs:{"cols":"11"}},[_c('span',[_vm._t("icon"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }